import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { Observable, of } from 'rxjs';

type ValidateDelegate = () => Observable<boolean>;

@Component({
  selector: 'app-wizard-step',
  templateUrl: './wizard-step.component.html',
  styleUrls: ['./wizard-step.component.scss'],
})
export class WizardStepComponent {
  private _isActive = false;
  isDisabled = true;

  @Output() next: EventEmitter<any> = new EventEmitter<any>();
  @Output() prev: EventEmitter<any> = new EventEmitter<any>();
  @Output() complete: EventEmitter<any> = new EventEmitter<any>();

  @Input() title: string;
  @Input() hidden = false;

  @Input() isValid = true;
  @Input() completed = false;

  @Input() showNext = true;
  @Input() showPrev = true;

  @Input() validateFunc: ValidateDelegate = () => of(this.isValid);

  @Input('isActive')
  set isActive(isActive: boolean) {
    this._isActive = isActive;
    this.isDisabled = false;
  }

  get isActive(): boolean {
    return this._isActive;
  }

  get showWarning(): boolean {
    return !!this.isValid && !this.isDisabled && !this.completed;
  }

  constructor() {}
}
